module.exports = __webpack_public_path__ + "img/全球时尚数据库ico.71c8fb22.png";